import { useEffect, useState } from "react";
import { Contact } from "@shared/types/UserAccountTypes.interface";
import { SvgIcon } from "@shared/components/Atoms/SvgIcon/SvgIcon";
import { IconNames } from "@shared/enums/icons.enums";
import Button from "@shared/components/Atoms/Button/Button";
import { useTranslations } from "@shared/context/useTranslations";
import { cn } from "@shared/helpers/classNames.helper";
import S from "./ContactCard.module.scss";
import { Chip } from "@shared/components/Atoms/Chip/Chip.component";

interface ContactCardProps {
    contact: Contact;
    isSelected?: boolean;
    onSelect: (contactId: string) => void;
}

export const ContactCard = ({ contact, isSelected, onSelect }: ContactCardProps) => {
    const { getTranslation } = useTranslations();
    const [iconKey, setIconKey] = useState(0);

    useEffect(() => {
        setIconKey((prevKey) => prevKey + 1);
    }, [isSelected]);

    return (
        <div
            className={cn(S.contactCard, isSelected && S.selected)}
            onClick={() => onSelect(contact.id!)}
        >
            <div className={S.contactInfo}>
                <h4>{contact.firstName} {contact.lastName}</h4>
                {contact.phone}
                <div className={S.contactInfoSmall}>
                    {contact.email}
                </div>
            </div>

            <div className={S.rightSection}>

                {contact.isPrimary && (
                    <Chip className={S.chip} label={getTranslation("contacts.primaryContact")} />
                )}                    

                {isSelected ? (
                    <div className={S.selectedBox}>
                        <SvgIcon
                            key={iconKey} // Force icon re-render via key update due to Safari SVG issue
                            iconName={IconNames.Checkmark}
                        />
                        {getTranslation("ContactCard.selected")}
                    </div>
                ) : (
                    <Button onClick={() => onSelect(contact.id!)}>
                        {getTranslation("ContactCard.select")}
                    </Button>
                )}
            </div>

        </div>
    );
};
